import { render, staticRenderFns } from "./FooterEdit.vue?vue&type=template&id=6f41b53c&scoped=true"
import script from "./FooterEdit.vue?vue&type=script&lang=js"
export * from "./FooterEdit.vue?vue&type=script&lang=js"
import style0 from "./FooterEdit.vue?vue&type=style&index=0&id=6f41b53c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f41b53c",
  null
  
)

export default component.exports